<div class="overlay-element" data-cy="overlay-element">
  <button class="btn-secondary"
    data-cy="overlay-element-first-button"
    [disabled]="!firstButtonEnabled"
  (click)="clickFirstButton()">{{firstButtonTitle}}</button>
  <button
    class="btn-primary-red"
    data-cy="overlay-element-second-button"
    [disabled]="!secondButtonEnabled"
    (click)="clickSecondButton()">{{secondButtonTitle}}
  </button>
  @if (isSpinner) {
    <app-loading-spinner data-cy="overlay-element-spinner" class="overlay-element-spinner"></app-loading-spinner>
  }
</div>
